// extracted by mini-css-extract-plugin
export default {"header__small":"reporting-module__header__small___lzPYq","header__large":"reporting-module__header__large___fx0j_","row_title":"reporting-module__row_title___G6WE8"};